/**
 * 프론트엔드 상수 정의 모듈입니다.
 *
 * 주요 상수:
 * - UI 색상 상수 (LONG_COLOR, SHORT_COLOR, 테마별 색상)
 * - 캔들 데이터 소스 라벨
 * - 기본 타임프레임
 * - 검색 옵션 기본값
 *
 * @remarks
 * CSS 변수를 사용할 수 없는 Canvas 등에서 색상 상수를 참조합니다.
 */
import { SearchOperatorType, SymbolGridColIds } from './enums';
import type { SearchOption } from './interface';

export const FONT_SIZE = 14; // 1rem과 -ant-font-size에 해당함. 주의!!! 이 값은 theme.css의 --fontSize와 같아야 함.

/** css 변수 형식을 사용하지 못하는 canvas 등에서 사용하는 색상 상수들 */
export const LONG_COLOR = '#2EBD85'; // var(--longColor)
export const SHORT_COLOR = '#F6465D'; // var(--shortColor)
export const ACCENT_COLOR = '#f47515'; // var(--accentColor)

// light mode
export const PRIMARY_COLOR = '#e6e6e6'; //--primaryColor
export const BORDER_COLOR = '#d9d9d9'; // --borderColor
export const CHART_GRID_COLOR = '#f3f3f3'; // --chartGridColor
export const CHART_TEXT_COLOR = '#333'; // 차트 텍스트에는 불투명도 설정이 불가능하므로 TEXT_COLOR를 사용할 수 없어서 별도 선언
export const CHART_BORDER_COLOR = '#ccc'; // --chartBorderColor
export const CHART_OVERLAY_BUTTON_BACK_COLOR = '#ffffff';
export const CHART_CIRCLE_COLOR = '#888'; // -- 롱/숏이 아닌 신호 매칭 동그라미

// dark mode
export const PRIMARY_COLOR_DARK = '#454545';
export const BORDER_COLOR_DARK = '#666'; // --borderColor
export const CHART_GRID_COLOR_DARK = '#1c1c1c'; // --chartGridColor
export const CHART_TEXT_COLOR_DARK = '#848E9C'; // 차트 텍스트에는 불투명도 설정이 불가능하므로 TEXT_COLOR를 사용할 수 없어서 별도 선언
export const CHART_BORDER_COLOR_DARK = '#252525'; // --chartBorderColor
export const CHART_OVERLAY_BUTTON_BACK_COLOR_DARK = '#454545';
export const CHART_CIRCLE_COLOR_DARK = '#ccc'; // -- 롱/숏이 아닌 신호 매칭 동그라미

// timeframes 기본값
export const ONE_DAY_TIMEFRAME = '1d';

// search-box-row 의 rowkey 의 key 앞부분 (row-1, row-2....)
export const SEARCH_BOX_ROW_KEY_PREV = 'row-';

export const defaultSearchOption: SearchOption = {
  field: SymbolGridColIds.SHORT_SYMBOL,
  operator: SearchOperatorType.INCLUDE,
  value: '',
};

export const COMMON_TOOLTIP_STYLE = { root: { whiteSpace: 'pre-line' } };

export const PAGE_URL = 'https://www.sageant.com/';
export const PAGE_URL_REGISTER = PAGE_URL + 'register';
export const PAGE_URL_PASSWORD_RESET = PAGE_URL + 'password/reset';
export const COPY_RIGHT = '(c) www.sageant.com All rights resevered. Since 2019';
